export const MCP_PRESETS_ENDPOINT = '/api/mcp/presets';
export const MCP_CONNECTORS_ENDPOINT = '/api/mcp/connectors';
export const MCP_TOOLS_ENDPOINT = '/api/mcp/tools';
export const MCP_OAUTH_START_ENDPOINT = (provider: string) =>
  `/api/mcp/oauth/${encodeURIComponent(provider)}/start`;
export const MCP_CONNECTOR_DISCOVER_ENDPOINT = (connectorId: string) =>
  `/api/mcp/connectors/${encodeURIComponent(connectorId)}/discover`;
export const MCP_CONNECTOR_DELETE_ENDPOINT = (connectorId: string) =>
  `/api/mcp/connectors/${encodeURIComponent(connectorId)}`;
export const MCP_TOOL_INVOKE_ENDPOINT = (toolId: string) =>
  `/api/mcp/tools/${encodeURIComponent(toolId)}/invoke`;
export const MCP_SERVERS_ENDPOINT = '/api/mcp/servers';
export const MCP_SERVER_DELETE_ENDPOINT = (serverId: string) =>
  `/api/mcp/servers/${encodeURIComponent(serverId)}`;
export const MCP_CONNECTOR_TOOLS_ENDPOINT = (connectorId: string) =>
  `/api/mcp/connectors/${encodeURIComponent(connectorId)}/tools`;
export const MCP_CONNECTOR_SETTINGS_ENDPOINT = (connectorId: string) =>
  `/api/mcp/connectors/${encodeURIComponent(connectorId)}`;
